import { Injectable } from '@angular/core';
import { combineLatestWith, Observable } from 'rxjs';
import { RiderView } from '@app/facade-services/rider-view/model/rider-view';
import { map } from 'rxjs/operators';
import { RiderFacadeService } from '@app/facade-services/rider/riders-facade.service';
import { FenceResultFacadeService } from '@app/facade-services/fence-result/fence-result-facade.service';
import { RiderEventFacadeService } from '@app/facade-services/rider-event/rider-event-facade.service';
import { SliceState } from '@app/store/faxe/sapiens-entity-state';
import { filterHighestGeneration, requiredSliceState } from '@app/domain/functions';
import { Rider } from '@app/rest-client/faxe/models/rider';
import { FenceResult } from '@app/rest-client/faxe/models/fence-result';
import { RiderEvent } from '@app/rest-client/faxe/models/rider-event';

@Injectable({
  providedIn: 'root'
})
export class RiderViewService {

  constructor(
    private readonly riderService: RiderFacadeService,
    private readonly fenceResultService: FenceResultFacadeService,
    private readonly riderEventService: RiderEventFacadeService) {
  }

  public selectRiderViews(
    raceGuid: string,
    fetch: boolean,
    allRequired: boolean,
    allGenerations: boolean,
    issuer: string): Observable<RiderView[]> {

    if (fetch) {
      this.fetchRiderViews(raceGuid, requiredSliceState(allRequired), issuer);
    }

    return this.riderService.selectRiderByRaceGuid(raceGuid, requiredSliceState(allRequired))
      .pipe(combineLatestWith(
          this.fenceResultService.selectFenceResultByRaceGuid(raceGuid, requiredSliceState(allRequired)),
          this.riderEventService.selectRiderEventByRaceGuid(raceGuid, requiredSliceState(allRequired))),
        map(([riders, fenceResults, riderEvents]) =>
          this.mapAndFilter(riders, fenceResults, riderEvents, allGenerations, issuer))
      );
  }

  private fetchRiderViews(raceGuid: string, requiredSliceState: SliceState, issuer: string): void {
    this.riderService.fetchRiders(raceGuid, issuer, requiredSliceState);
    this.fenceResultService.fetchFenceResult(raceGuid, requiredSliceState, issuer);
    this.riderEventService.fetchRiderEvent(raceGuid, requiredSliceState, issuer);
  }

  private mapAndFilter(riders: Rider[], fenceResults: FenceResult[], riderEvents: RiderEvent[], allGenerations: boolean,  issuer: string): RiderView[] {

    console.log('R (' + riders?.filter(r => r.isReportable).length + ', ' + riders?.filter(r => !r.isReportable).length + ') FR ' + fenceResults?.length, 'RE ' + riderEvents?.length, 'AllGen ' + allGenerations, 'Issuer ' + issuer);
    return riders
      .map(rider => ({
        ...rider,
        fenceResults: filterHighestGeneration(fenceResults.filter(fr => fr.riderGuid === rider.riderGuid), allGenerations),
        riderEvents: riderEvents.filter(re => re.riderGuid === rider.riderGuid)
      }));
  }

}
